<template>
  <div v-if="isDisplayedConvertResult" data-test="convert-block">
    <p v-if="isMountedInVariant" class="convert-result-label" data-test="convert-label">
      {{ i18n._('Quantité calculée') }}
    </p>
    <adn-button
      kind="link"
      v-if="isMountedInVariant"
      class="convert-result-label xs"
      v-scroll-to="{
        el: '#calculator',
        offset: -130,
      }"
      data-test="convert-label"
    >
      {{ i18n._('Quantité calculée') }}
    </adn-button>
    <p class="convert-result" :class="{ 'in-variant': isMountedInVariant }">
      <output v-if="!isNaN(packageConvertResult[state.unit].numberOfBigPackage)" data-test="big-package">
        {{ formatMeasureUnit(packageConvertResult[state.unit].numberOfBigPackage, packageType(state.unit, true)) }}
      </output>
      <output
        v-if="
          !isNaN(packageConvertResult[state.unit].numberOfBigPackageInMix) &&
          !isNaN(packageConvertResult[state.unit].numberOfSmallPackageInMix)
        "
        data-test="mix-packages"
      >
        {{
          `${formatMeasureUnit(
            packageConvertResult[state.unit].numberOfBigPackageInMix,
            packageType(state.unit, true),
          )} + ${formatMeasureUnit(
            packageConvertResult[state.unit].numberOfSmallPackageInMix,
            packageType(state.unit, false),
          )}`
        }}
      </output>
      <output v-if="!isNaN(packageConvertResult[state.unit].numberOfSmallPackage)" data-test="small-package">
        <span
          v-if="
            !isNaN(packageConvertResult[state.unit].numberOfBigPackageInMix) &&
            packageConvertResult[state.unit].numberOfBigPackageInMix
          "
        >
          {{ i18n._('ou') }}
        </span>
        {{ formatMeasureUnit(packageConvertResult[state.unit].numberOfSmallPackage, packageType(state.unit, false)) }}
      </output>
    </p>
  </div>
</template>

<script lang="ts">
import { formatMeasureUnit } from '@b2ag/l10n'
import { i18n } from '@b2ag/locale'
import { computed, defineComponent } from 'vue'
import { packagingConvert } from '../../calculator.business'
import { useCalculator } from '../../composables/useCalculator'
import { packageType } from './helpers'
import AdnButton from '@b2ag/design-system/src/components/AdnButton/AdnButton.vue'

export default defineComponent({
  name: 'PConvertResult',
  props: {
    productId: {
      type: String,
      required: true,
    },
    isMountedInVariant: Boolean,
  },
  components: {
    AdnButton,
  },
  setup(props) {
    const { packagingOptions, result, state, hasPositiveConvertResult } = useCalculator(props.productId)

    const packageConvertResult = computed(() => {
      if (!result.value) return {}
      return packagingConvert(packagingOptions, result.value)
    })

    const isDisplayedConvertResult = computed(() => {
      return (
        (!props.isMountedInVariant && packageConvertResult.value[state.value.unit]) ||
        (props.isMountedInVariant && hasPositiveConvertResult.value)
      )
    })

    return {
      packagingOptions,
      result,
      state,
      hasPositiveConvertResult,
      packageConvertResult,
      isDisplayedConvertResult,
      formatMeasureUnit,
      packageType,
      i18n,
    }
  },
})
</script>

<style lang="scss" scoped>
.convert-result {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 2rem;

  output {
    line-height: 2.2rem;
  }

  output:first-child {
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  &.in-variant {
    flex-direction: row;
    justify-content: center;

    output:first-child {
      margin-right: 1rem;
    }

    @media (min-width: $breakpoint-md) {
      justify-content: flex-start;
    }
  }
}

.convert-result-label {
  font-weight: bold;
  display: none;

  &.xs {
    display: block;
    color: var(--color-white);
    margin: auto;
    min-height: 2.8rem;
    line-height: 2.8rem;
    padding-top: 2rem;
  }

  @media (min-width: $breakpoint-md) {
    display: block;

    &.xs {
      display: none;
    }
  }
}
</style>
